import React from 'react';
import css from './form-error.module.scss';
import clsx from 'clsx';

const FormError = ({ error, size }: { error?: string; size?: string }) => {
  if (!error) {
    return null;
  }

  return (
    <div className={clsx(css.error, size && css[`size-${size}`])}>{error}</div>
  );
};

export default FormError;
